export default "__VITE_PUBLIC_ASSET__56752cb3__"